import { JetView } from 'webix-jet';
import { devConfig, countries, profile, cashDesks, agentList, walletsList } from 'config/config';

/**
 * Class representing the filter view for the management report.
 * @extends JetView
 */
export default class FilterInformeGerencialView extends JetView {
    /**
     * Configures the UI components of the filter view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const left = {
            margin: 5,
            id: 'a1',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'a1',
                    cols: [
                        {
                            view: 'datepicker', // Date picker for selecting a date
                            name: 'Date',
                            id: 'Date',
                            stringResult: false,
                            minWidth: 200,
                            type: 'month',
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label for the date picker
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: new Date(), // Default value set to current date
                            format: '%M %Y', // Date format
                        },
                        {
                            view: 'richselect', // Dropdown for country selection
                            name: 'CountrySelect',
                            id: 'CountrySelect',
                            localId: 'regions:combo',
                            label: "<span class='icon-language'></span>" + _('País'), // Label for the country select
                            labelPosition: 'top',
                            minWidth: 200,
                            placeholder: _('Click para seleccionar '),
                            on: {
                                onChange: function (data, obj) {
                                    // Event handler for change event
                                    var currentValue = this.getValue();
                                    if (screen.width > 600) {
                                        if (currentValue.length > 0) {
                                            $$('consultDesk').enable(); // Enable button if a country is selected
                                        } else {
                                            $$('consultDesk').disable(); // Disable button if no country is selected
                                        }
                                    } else {
                                        if (currentValue.length > 0) {
                                            $$('consultDesk2').enable(); // Enable button for smaller screens
                                        } else {
                                            $$('consultDesk2').disable(); // Disable button for smaller screens
                                        }
                                    }
                                },
                            },
                            options: {
                                body: {
                                    template: function (obj) {
                                        // Template for displaying country options
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries, // Data source for countries
                                },
                            },
                            hidden:
                                devConfig.getCountryReport() || // Hide if country report is enabled
                                !devConfig.getPermAction(
                                    'filterByCountry',
                                    'Add', // Check permission for filtering by country
                                ),
                            css: 'prm-filterByCountry',
                        },
                        {
                            view: 'richselect', // Read-only dropdown for selected country
                            name: 'CountrySelect2',
                            localId: 'regions:combo',
                            label: "<span class='icon-language'></span>" + _('País'), // Label for the country select
                            labelPosition: 'top',
                            minWidth: 200,
                            placeholder: _('Click para seleccionar '),
                            value: profile.Settings.ReportCountry, // Default value from profile settings
                            readonly: true, // Set as read-only
                            options: {
                                body: {
                                    template: function (obj) {
                                        // Template for displaying country options
                                        return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                    },
                                    data: countries, // Data source for countries
                                },
                            },
                            hidden:
                                !devConfig.getCountryReport() || // Hide if country report is not enabled
                                !devConfig.getPermAction(
                                    'filterByCountry',
                                    'Add', // Check permission for filtering by country
                                ),
                            css: 'prm-filterByCountry country-hide', // CSS classes for styling
                        },
                        {
                            view: 'richselect', // Dropdown for selecting bet type
                            name: 'TypeBet',
                            label: _('Tipo de Apuesta'), // Label for bet type
                            labelPosition: 'top',
                            minWidth: 200,
                            placeholder: _('Click para seleccionar '),
                            value: 2, // Default value
                            options: [
                                { id: '1', value: _('Apuestas Creadas') }, // Option for created bets
                                { id: '2', value: _('Apuestas Cerradas') }, // Option for closed bets
                            ],
                        },
                        {
                            view: 'combo', // Dropdown for wallet type selection
                            name: 'WalletId',
                            minWidth: 200,
                            localId: 'wallet:combo',
                            hidden:
                                devConfig.getPartnerSelected() !== '2' // Hide based on partner selection
                                    ? true
                                    : false,
                            label: _('Tipo de Billetera'), // Label for wallet type
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            suggest: walletsList, // Data source for wallets
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    height: screen.width > 500 && screen.height > 500 ? 0 : 120, // Conditional height based on screen size
                    cols: [
                        {
                            view: 'radio', // Radio buttons for user type selection
                            name: 'TypeUser',
                            label: _('Tipo de usuario'), // Label for user type
                            labelPosition: 'top',
                            value: 0, // Default value
                            options: [
                                { id: 0, value: _('Todos') }, // Option for all users
                                {
                                    id: 1,
                                    value: "<span class='icon-players'></span> ", // Option for player type
                                },
                                {
                                    id: 2,
                                    value: "<span class='icon-shop'></span>", // Option for shop type
                                },
                            ],
                        },
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Include the left section in the upper section
                },
            ],
        };
        const buttons = {
            cols: [
                {},
                {
                    view: 'button', // Button to clear the form
                    value: _('Limpiar'),
                    width: screen == 'small' ? 0 : 100,
                    minWidth: 200,
                    click: () => {
                        $$('myForm').setValues($$('myForm').getCleanValues()); // Reset form values
                        $$('CountrySelect').setValue(
                            $$('myForm').getCleanValues().CountrySelect, // Reset country selection
                        );
                        $$('Datepicker').setValue(''); // Reset date picker
                    },
                },
                {
                    view: 'button', // Button to consult/filter data
                    value: _('Consultar'),
                    hotkey: 'enter', // Shortcut key for the button
                    id: 'consultDesk',
                    type: 'form',
                    width: screen == 'small' ? 0 : 100,
                    disabled: true, // Initially disabled
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get form values
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country selection based on profile
                        }
                        delete filterdata['CountrySelect2']; // Remove unnecessary field
                        this.app.callEvent('informeGerencial:filter', [
                            filterdata, // Trigger filter event with data
                        ]);
                        $$('b5').collapse(); // Collapse the filter section
                        $$('a5').scrollTo(100, 0); // Scroll to a specific position
                    },
                },
            ],
        };
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: 'button', // Button to clear the second form
                    value: _('Limpiar'),
                    click: () => {
                        $$('myForm2').setValues($$('myForm2').getCleanValues()); // Reset form values
                        $$('CountrySelect').setValue(
                            $$('myForm2').getCleanValues().CountrySelect, // Reset country selection
                        );
                        $$('Datepicker').setValue(''); // Reset date picker
                    },
                },
                {
                    view: 'button', // Button to consult/filter data in the second form
                    value: _('Consultar'),
                    hotkey: 'enter', // Shortcut key for the button
                    type: 'form',
                    id: 'consultDesk2',
                    disabled: true, // Initially disabled
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get form values
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country selection based on profile
                        }
                        delete filterdata['CountrySelect2']; // Remove unnecessary field
                        this.app.callEvent('informeGerencial:filter', [
                            filterdata, // Trigger filter event with data
                        ]);
                    },
                },
            ],
        };
        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion component for filters
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for the accordion
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Include upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            view: 'scrollview', // Scrollable view for the second form
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section], // Include upper section
            },
        };
        const filterPopup = webix.ui({
            // Popup window for filters
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Label for the popup
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide the popup on click
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2',
                type: 'clean',
                rows: [accordion_section3, buttons2], // Include accordion and buttons
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule for the form
                },
            },
        });
        return {
            view: 'form',
            id: 'myForm',
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section2 // Include accordion section based on screen size
                    : { height: 1, width: 0 },
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for the form
            },
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            if (devConfig.getCountryReport()) {
                if (screen.width > 600) {
                    $$('consultDesk').enable(); // Enable button for larger screens
                } else {
                    $$('consultDesk2').enable(); // Enable button for smaller screens
                }
            }
        });
    }
}

// FILE DOCUMENTED
